export const systemDefaultCurrency = 'EUR';
